<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <div header-tag="header" header-bg-variant="dark">
        <!-- <template #header>
          <h5 class="mb-0" style="color: #fff">
            <strong>{{ $store.state.table.asuransi }}</strong>
          </h5>
        </template> -->
        <CRow>
          <!-- <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol> -->
        </CRow>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <td>
                  <!-- <b-button
                    variant="warning"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Edit Data'"
                    v-b-modal.modal-edit-ditolak
                    @click="(data = item), (edit = !edit)"
                  >
                    <CIcon name="cil-pencil" />
                  </b-button> -->
                  <b-button
                    variant="info"
                    class="mr-1"
                    v-c-tooltip.hover.click="'Riwayat'"
                    v-b-modal.modal-riwayat-tolak
                    :disabled="$store.state.role_aktif.kodeRole != 'super' && !item.mitraId"
                    @click="(data = item), (detail = !detail)"
                  >
                    <CIcon name="cil-info" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </div>
    </CCol>
    <modal-edit :data="data" :loker="loker" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-riwayat :data="data" :detail="detail" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalEdit from "./modalEdit.vue";
import modalRiwayat from "./modalRiwayat.vue";

export default {
  components: {
    modalEdit,
    modalRiwayat,
  },
  name: "asuransi",
  props: ["refreshDitolak"],
  data() {
    return {
      edit: false,
      detail: false,
      data: {},
      loker: [],
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaPengirim",
          label: "Nama Pelamar",
          _style: "max-width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatPengirim",
          label: "Alamat",
          _style: "max-width: 25%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "emailPengirim",
          label: "Email",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaLoker",
          label: "Lowongan",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: "Posisi Pelamar",
          _style: "width: 10%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          _style: "width: 10%;",
          class: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ],
      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    this.getDatas();
    this.getLoker();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    refreshDitolak(newVal, oldVal) {
      if (newVal != oldVal && newVal) {
        this.getDatas();
        this.$emit("changeVar", { name: "refreshDitolak", data: false });
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPelamarDitolak = await vm.$axios.post("/postLoker/listAllRiwayatDitolakPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listPelamarDitolak", listPelamarDitolak);
      vm.items =
        listPelamarDitolak.data.status == 200
          ? listPelamarDitolak.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.postLokerId,
                namaMitra: x.namaMitra || " - ",
                // posisiDilamar: `${x.namaLoker} - (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
      vm.totalRows = parseInt(listPelamarDitolak.data.count);
      vm.loading = false;
    },
    async getLoker() {
      let vm = this;
      let listLoker = await vm.$axios.post("/loker/list");
      vm.loker =
        listLoker.data.status == 200
          ? listLoker.data.data.map((x) => {
              return {
                ...x,
                posisiDilamar: `${x.namaLoker} - (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
